import { BaseService } from './base-service';
export class DashboardService {
    static getDashboardTiles() {
        return BaseService.get(`dashboard-tiles`);
    }
}
